module.exports = __webpack_public_path__ + "assets/img/b194fc167b5b0d0fe6eeca2a5858cb0d.png";